import { useState } from 'react';

import TituloSessao from '../componentes/TituloSessao';
import SelectTipoRelatorio from '../componentes/SelectTipoRelatorio';

import DownloadRelatoriosTabela from '../componentes/DownloadRelatoriosTabela';

function DownloadRelatorios() {

    console.log(' #### Iniciando DownloadRelatorios ####');
    const [tipoRelatorio, setTipoRelatorio] = useState(null)

    return (
        <div className='pagina-tamanho-minimo container d-flex flex-column align-items-center'>
            <TituloSessao titulo='Download de Relatórios NTM' barraDecorativa={false} />
            <div className='container div-com-borda p-3 aligm-items-center'>
                <h2 className='tituloSecundario text-center text-md-start'>Filtros</h2>
                <SelectTipoRelatorio setTipoRelatorio={setTipoRelatorio} />
            </div>
            { tipoRelatorio && <DownloadRelatoriosTabela tipoRelatorio={tipoRelatorio.codigo} /> }
        </div>
    );
}

export default DownloadRelatorios
